import React, {useState} from 'react';
import Header from "../../../layouts/Header";
import {BiCategoryAlt,  BiSolidCube} from "react-icons/bi";
import {FaArrowTrendDown, FaArrowTrendUp} from "react-icons/fa6";
import {BsWallet} from "react-icons/bs";
import {showError} from "../../../utils/toastHelper";
import {getWalletDetail} from "../api/ProfileAPIs";
import Loading from "../../../layouts/Loading";

const currencyFormat = Intl.NumberFormat('en-US');
export default function Wallet() {

    const [loading, setLoading] = useState(true);
    const [wallet, setWallet] = React.useState([]);

    React.useEffect(() => {

        const fetchTransactions = async () => {
            const params = {

            }
            try {
                const data = await getWalletDetail(params);
                setWallet(data.data);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();

    }, []);

    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='کیف پول' hasBack={true}/>

            <section className="container mt-3 rtl py-5 ">

                <div className="row text-center m-2 py-2 transaction-box bg-primary-subtle text-dark border-0">
                    <div className="col-1">
                        <BsWallet   />
                    </div>
                    <div className="col-5 text-end text-small-1">
                        موجودی کیف پول:
                    </div>
                    <div className="col-6 fw-bold text-start">
                        {currencyFormat.format(wallet.balance)}
                        &nbsp;
                        ریال
                    </div>
                </div>
            </section>

            <section className="container mt-3 rtl pb-5 mb-5 ">
                <div className="row">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>
                       آخرین تراکنش ها
                    </div>
                </div>
                {
                    !loading && wallet?.transactions.map (transaction => {
                        return (
                            <div className="row transaction-box m-3 p-3 " key={transaction.id}

                            >
                                <div className="col-7 text-small-2 fw-bold">
                                    {
                                        transaction.increase_amount > 0 ?
                                            <FaArrowTrendUp  className='text-success ms-2 fw-bold text-big-2' />
                                            :
                                            <FaArrowTrendDown className='text-danger ms-2 fw-bold text-big-2' />
                                    }
                                    {
                                        transaction.title
                                    }

                                    <div className='fw-normal text-small-3 text-muted mt-2'>
                                        <BiSolidCube className='ms-2' />
                                        { transaction.description}
                                        <span className='tr_code badge badge-pill badge-primary bg-dark mx-2 text-small-1 '>
                                            {
                                                transaction.type
                                            }

                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 fw-bold text-start text-dark text-small-1">
                                    {
                                        transaction.increase_amount > 0 ?
                                            currencyFormat.format(transaction.increase_amount)
                                            :
                                            currencyFormat.format(transaction.decrease_amount)
                                    }
                                    &nbsp;
                                    <span className='text-small-4'>ریال</span>
                                    <div className='mt-3 text-small-3 text-muted'>
                                        {transaction.date}
                                    </div>
                                </div>

                            </div>
                        )
                    })
                }
                {
                    !loading && wallet.transactions.length === 0 ?
                        <div className='alert alert-secondary text-center text-small-2 mt-3'>
تراکنشی در کیف شما پیدا نشد

                        </div> : ''
                }
            </section>

        </React.Fragment>

    );
}

